import {ReactNode} from "react";
import {MantineProvider} from "@mantine/core";
import {Notifications} from "@mantine/notifications";
import Theme from "./Theme";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import {ModalsProvider} from "@mantine/modals";

type WrapMantineProps = {
    children: ReactNode;
}

/**
 * Wraps children inside entire Mantine context.
 * Including themes, containers etc.
 * @author Kacper Faber
 * @since 0.1.0
 * @param props
 * @constructor
 */
function WrapMantine(props: WrapMantineProps) {
    return (
        <MantineProvider defaultColorScheme="light" theme={Theme}>
            <Notifications/>

            <ModalsProvider/>

            { props.children }
        </MantineProvider>
    );
}

export default WrapMantine;